"use client"

import { addToClientCart as addToClientTryCart, removeFromClientCart as removeFromClientTryCart } from "@/app/store/slices/try-cart/tryCartSlice";
import { addToTryBasketThunk, removeFromTryCartThunk } from "@/app/store/slices/try-cart/tryCartThunk";
import { ProductDetailType } from "@/app/types/product-site";
import { ClientTryCartItemType } from "@/app/types/tryCart";
import { Box, Button, colors, Fade, IconButton, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import FlexBox from "@v2/components/styled/FlexBox";
import { useAppDispatch, useAppSelector } from "@v2/lib/redux/hooks";
import { ArrowLeft, Shirt } from "lucide-react";
import Link from "next/link";
import { closeSnackbar, useSnackbar } from "notistack";
import { useCallback } from "react";

export default function PdpAddToTryCartHandler({
    showProduct,
    site_product_details
}: {
    showProduct: ProductDetailType,
    site_product_details: {
        slug: string;
        title: string;
    };

}) {

    const dispatch = useAppDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const theme = useTheme()
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

    const { loading: addToTrCartInProcess, fetchingCart: serverTrCartIsLoading } = useAppSelector((store) => store.tryCart);

    const isAuthenticated = useAppSelector(s => s.general.session?.isAuthenticated) ?? false
    // Before the session loads a logged-in user looks like a guest, and the
    // item would land in the guest try cart.
    const sessionLoaded = useAppSelector(s => s.general.sessionLoaded)

    const serverTryCart = useAppSelector(s => s.tryCart.serverTryCart?.items)
    const clientTryCart = useAppSelector(s => s.tryCart.clientTryCart?.items)

    const isInTryCart = isAuthenticated ? serverTryCart?.some(i => i.product_id === showProduct.product_id)
        : clientTryCart?.some(i => i.product.product_id === showProduct.product_id)

    const currentCount = isAuthenticated ? (serverTryCart?.length ?? 0) : (clientTryCart?.length ?? 0)

    const tryIsDisabled = currentCount > 7;

    // ? useAppSelector(s => s.tryCart.serverTryCart?.items?.some(i => i.product_id === showProduct.product_id))
    // : useAppSelector(s => s.tryCart.clientTryCart?.items?.some(i => i.product.product_id === showProduct.product_id));



    const addToTryCart = useCallback(() => {
        if (!sessionLoaded) return;
        if (tryIsDisabled) return enqueueSnackbar({
            autoHideDuration: 5000,
            hideIconVariant: true,
            variant: 'warning',

            message: (
                <FlexBox sx={{
                    justifyContent: 'space-between',
                    // width: 200
                }}>
                    <Tooltip arrow title="برو به سبد پرو" placement="top">
                        <IconButton onClick={() => closeSnackbar()} component={Link} prefetch={false} href={`/fa/cart/try`} sx={{
                            height: 36,
                            width: 36,
                            mr: 1

                        }}>
                            <ArrowLeft size={18} color="#fff" style={{
                                position: 'relative',
                                top: 2
                            }} />
                        </IconButton>
                    </Tooltip>
                    <Typography sx={{ fontSize: 14 }}>سبد پرو تکمیل شده است</Typography>
                    {/* <Button color="inherit" variant="outlined" component={Link} prefetch={false} href={`/fa/cart/try`} sx={{
                        mt: 1, minWidth: 68
                    }}>برو به سبد پرو</Button> */}
                </FlexBox>
            ),
        })
        if (!isAuthenticated) {
            const tryCartProductItem: ClientTryCartItemType = { ...showProduct }
            tryCartProductItem.site_product_details = site_product_details;
            dispatch(addToClientTryCart(tryCartProductItem));
        } else {
            dispatch(addToTryBasketThunk(showProduct.product_id));
        }

        enqueueSnackbar({
            message: 'کالا به سبد پرو اضافه شد',
            variant: 'success'
        })


    }, [isAuthenticated, sessionLoaded, showProduct, tryIsDisabled])

    const removeFromTrtCart = useCallback(() => {
        if (!isAuthenticated) {
            dispatch(removeFromClientTryCart(showProduct))
        } else {
            dispatch(removeFromTryCartThunk(showProduct.product_id));
        }

        closeSnackbar()

    }, [isAuthenticated, showProduct])

    return <>

        <Box sx={{ flex: 1, }}>
            {(isInTryCart) && (
                <FlexBox sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                    {isDesktop && (
                        <FlexBox>
                            <Shirt />
                            <Typography component="span" sx={{ ml: 1, fontSize: 14, color: colors.grey[800] }}>
                                به سبد پرو اضافه شده
                            </Typography>
                        </FlexBox>
                    )}
                    <Fade in={true}>
                        <Button sx={{
                            // width: 1,
                            height: 48,
                            flex: isDesktop ? 'unset' : 1,
                        }} color="inherit" variant="contained" disableElevation onClick={removeFromTrtCart} loading={addToTrCartInProcess || serverTrCartIsLoading}>
                            {isDesktop ? "حذف" : "حذف از سبد پرو"}
                        </Button>
                    </Fade>
                </FlexBox>
            )}

            {!isInTryCart && (
                <Fade in={true}>
                    <Button
                        // disabled={tryIsDisabled}
                        sx={{
                            width: 1,
                            height: 48,
                        }}
                        color="inherit"
                        variant="outlined"
                        onClick={addToTryCart}
                        loading={addToTrCartInProcess || serverTrCartIsLoading || !sessionLoaded}
                    // endIcon={tryIsDisabled ? '' : ''}
                    >
                        میخوام پرو کنم !
                        {/* {tryIsDisabled ? "سبد پرو پر شده" : "میخوام پرو کنم !"} */}

                    </Button>
                </Fade>
            )}
        </Box >
    </>
}